export default {
  name: 'SettingHexagonIcon',
  props: {
    width: {
      type: Number,
      default: 24
    },
    height: {
      type: Number,
      default: 24
    },
    color: {
      type: String,
      default: '#4D4D4D'
    }
  }
};